import React, { useCallback, useContext, useEffect } from "react";
import {EncryptedPubKey, PaymentInfoContext, PaymentRequest} from "../../App";
import useStyles from "./styles";
import { useTranslation } from 'react-i18next';
import GooglePay from "../GooglePay";
import ApplePay from "../ApplePay";
import {CreatePaymentContext} from "../../pages/CheckoutForm";
import {PaymentMethodsTypes, allowedCardsBrands} from "../../constants";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {Autoplay} from 'swiper';
import 'swiper/swiper.scss';
import {ProviderTypeContext} from "../../containers/InitCheckoutContainer";
import EmbeddedApplePayButton from "../ApplePayEmbedded";

const PaymentButton = ({isPaymentByWalletAllowed = {
    applePay: null,
    googlePay: null
}}) => {
  SwiperCore.use([Autoplay])
  const paymentInfo = useContext(PaymentInfoContext);
  const paymentRequest = useContext(PaymentRequest);
  const encryptedPubKey = useContext(EncryptedPubKey);
  const createPayment = useContext(CreatePaymentContext);
  const {providerType} = useContext(ProviderTypeContext);
  const disallowedCardBrands =  paymentInfo?.disallowedCardBrands || [];
  const brands = allowedCardsBrands.filter((brand) => !disallowedCardBrands.includes(brand))

  const classes = useStyles();
  const {t} = useTranslation();

  const makePayment = useCallback((tokenData, paymentMethodType) => {
    const payload = {
      paymentProviderType: 2,
      paymentMethodType,
      currency: paymentInfo?.currency,
      country: paymentInfo?.country,
      merchantId: encryptedPubKey,
      tokenData,
    };

    if (createPayment && typeof createPayment === 'function') {
      createPayment(payload);
    }
  }, [createPayment, paymentInfo, encryptedPubKey]);

  useEffect(() => {
    const handleMessageFromHost = (event) => {

      const { type, payload } = event.data || {};
      let paymentToken = typeof payload === "string" ? JSON.parse(payload) : payload;
      if (type === 'success-apple-pay') {
        console.error('success-apple-pay', paymentToken);
        makePayment(paymentToken, PaymentMethodsTypes.ApplePay);
      } else if (type === 'fail-apple-pay') {
        console.error('Apple Pay canceled/failed:', paymentToken);
      }
    };

    window.addEventListener('message', handleMessageFromHost);
    return () => {
      window.removeEventListener('message', handleMessageFromHost);
    };
  }, [makePayment]);
  const isEmbedded = window.self !== window.top;

  return (
    <div className={`applePayContainer ${brands.length <= 4 ? 'centered-swiper-layout' : ''}`} >
        {paymentInfo?.isPaymentByCardAllowed && isPaymentByWalletAllowed.googlePay && (
            <GooglePay
                country={paymentInfo?.country}
                currency={paymentInfo?.currency}
                price={paymentInfo?.amount}
                merchantId={paymentInfo?.paymentAccountPubKey}
                merchantName={paymentInfo?.companyName}
                externalMerchantId={isPaymentByWalletAllowed?.googlePay?.externalMerchantId}
                disallowedCardBrands={disallowedCardBrands}
                onSuccess={(tokenData) => makePayment(tokenData, PaymentMethodsTypes.GooglePay)}
            />
        )}
        {paymentInfo?.isPaymentByCardAllowed && isPaymentByWalletAllowed.applePay && (
            <ApplePay
                country={paymentInfo?.country}
                currency={paymentInfo?.currency}
                price={paymentInfo?.amount}
                description={paymentInfo?.description}
                externalMerchantId={isPaymentByWalletAllowed?.applePay?.externalMerchantId}
                disallowedCardBrands={disallowedCardBrands}
                onSuccess={(tokenData) => makePayment(tokenData, PaymentMethodsTypes.ApplePay)}
                isEmbedded = {isEmbedded}
            />
        )}
        
      {/*{(paymentRequest && paymentInfo?.isPaymentByCardAllowed && isPaymentByWalletAllowed) && (*/}
      {/*  <PaymentRequestButtonElement options={{ paymentRequest }} />*/}
      {/*)}*/}

      <div className={`${classes.brandsWrapper} brandsWrapper`}>
        {(paymentRequest && paymentInfo?.isPaymentByCardAllowed && isPaymentByWalletAllowed) && (
          <div className={`${classes.brandsWrapperTitle}`}>
            <span>{t('Or_pay_with_card')}</span>
          </div>
        )}
        {paymentInfo?.isCardBrandBannerVisible && (
            <>
                <div className={`${classes.swiperWrapper}`}>
                    <Swiper
                        spaceBetween={0}
                        slidesPerView={4}
                        allowTouchMove={false}
                        autoplay={brands.length > 4 && {
                            delay: 2500,
                            disableOnInteraction: true,
                        }}
                        modules={[Autoplay]}
                    >
                        {brands.map((brand, i) => {
                            return (<SwiperSlide key={`${brand}-${i}`}>
                                <div className={classes.swiperSlide}>
                                    <img className={classes.brandsImageSingle} src={`/assets/images/brands/${brand}.svg`} alt={brand.toLowerCase()} />
                                </div>
                            </SwiperSlide>)
                        })}
                    </Swiper>
                </div>
            </>
        )}
      </div>
    </div>
  );
}

export default PaymentButton;
